import React from 'react';
import { Container, Typography, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import imgstorefront from "../images/thainoodlestorefront.jpg";

const useStyles = makeStyles(theme => ({
    container: { 
        paddingTop: 50, 
        paddingBottom: 50,
    },
    profilePicture:{
        width: 200,
        height: 200,
        paddingTop: 5,
        borderRadius: '50%',
    }
  }))

const About = ({id}) => {
    const classes = useStyles();
    return (
        <Container maxWidth='lg' className={classes.container} id={id}>
            <Grid container direction='row'>
                <Grid item xs={12} sm={4} >
                    <img src={imgstorefront} className={classes.profilePicture} alt=""/>
                </Grid>
                <Grid item xs={12} sm={8} >
                    <Typography variant="body1" component="div" align='left' >
                    Thai Noodle would like to invite you to come try our various Thai dishes. We have been opened sinced 2010. Most people would describe us as a "hole in a wall" with great Thai food. While that is true, our goal is simply to server you the best cook meal straight from our small kitchen.
                    </Typography>
                    <Typography variant="body1" component="div" align='left' style={{paddingTop: 20}} >
                     We have one cook and one waiter. Some orders might require more time to prepare than others, so we greatly appreciate your patience. We hope that you will enjoy our cooking and thank you for visiting us.
                    </Typography>
                    <Typography align='left' style={{paddingTop: 20}} >We will try our best accomidate for any food allergies or vegiterian or vegan style preference. Please be sure to let us know when placeing your order on any special requests. ** May not be available on some menu items **  </Typography>
                </Grid>
            </Grid>
        </Container>
    );
}

export default About;